import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-warning-before-upload',
  templateUrl: './image-warning-before-upload.component.html',
  styleUrls: ['./image-warning-before-upload.component.css']
})
export class ImageWarningBeforeUploadComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/image-warning-before-upload/image-warning-before-upload.component.ts